import NcInputNumberLocalities from "components/NcInputNumberLocalities/NcInputNumberLocalities";
import {TimerProvider} from "contexts/TimerContext";
import {LocalitySelectedType, RaffleComboType} from "data/types";
import {FC, useEffect, useState} from "react";
import {useGetCombosQuery} from "store/api";

export interface CommbosProps {
  defaultValue?: number;
  eventId: string;
  max?: number;
  onChange?: (value: number) => void;

  localityId: string;
  haveSelection?: boolean;
  haveDiscount: boolean;
  enablePurchase: boolean;
  startTime: string;
  maxQuantity: number;
  currentQuantity: number;
  endTime: string;
  localitiesSelected: LocalitySelectedType[];
  setLocalitiesSelected: React.Dispatch<
    React.SetStateAction<LocalitySelectedType[]>
  >;
}

export const Combos: FC<CommbosProps> = ({
  defaultValue = 0,
  max,
  onChange,

  eventId,
  localityId,
  haveDiscount,
  haveSelection = false,
  enablePurchase,
  startTime,
  maxQuantity,
  currentQuantity,
  endTime,
  localitiesSelected,
  setLocalitiesSelected,
}) => {
  const {data} = useGetCombosQuery(eventId);
  const [combos, setCombos] = useState<RaffleComboType[]>([]);
  const [selectedCombo, setSelectedCombo] = useState<RaffleComboType>();
  const [minQuantity, setMinQuantity] = useState<number>(0);
  useEffect(() => {
    if (data) {
      setCombos(data.list);
    }
  }, [data]);

  useEffect(() => {
    if (combos.length > 0) {
      const minCombo = combos.reduce((a, b) =>
        a.quantity < b.quantity ? a : b
      );
      setMinQuantity(minCombo.quantity + 1);
    }
  }, [combos]);

  const handleClickIncrement = (quantity: number) => {
    if (max && max <= quantity) return;
    setLocalitiesSelected((prevLocalities) => {
      return prevLocalities.map((locality) =>
        locality._id === localityId
          ? {...locality, quantity: quantity}
          : locality
      );
    });
    onChange && onChange(quantity);
  };

  return (
    <div className="mt-12">
      <span className="block text-center text-sm text-gray-500 dark:text-gray-400 mb-4">
        No te quedes fuera 🤩. Elige tu combo favorito y aumenta tus
        posibilidades de ganar. ¡Mientras más números tengas, más cerca estarás
        del premio! 🎁✨
      </span>

      <div className="flex flex-wrap gap-4 justify-center">
        {combos.map((combo) => (
          <div
            key={combo._id}
            onClick={
              max! >= combo.quantity
                ? () => {
                    handleClickIncrement(combo.quantity);
                    setSelectedCombo(combo);
                  }
                : undefined
            }
            className={`relative border rounded-3xl p-4 w-48 flex flex-col items-center
    transition duration-300 ease-in-out transform
              ${max! >= combo.quantity ? "cursor-pointer hover:scale-105" : ""}
              ${
                selectedCombo?._id === combo._id
                  ? "border-primary-500 bg-primary-100 dark:bg-primary-900"
                  : "border-gray-200 dark:border-neutral-700"
              }
            `}
          >
            {combo.isPopular && (
              <span
                className="absolute top-2 right-2 bg-primary-500 text-black text-xs font-bold px-3 py-1 shadow-md
               rounded-tl-lg rounded-tr-2xl rounded-br-lg rounded-bl-2xl"
              >
                Popular
              </span>
            )}
            {max! <= combo.quantity && (
              <span
                className="absolute bottom-2 left-2 dark:bg-red-900 bg-red-500 dark:text-black text-white text-xs font-bold px-2 py-1 shadow-md
               rounded-tl-lg rounded-tr-2xl rounded-br-lg rounded-bl-2xl"
              >
                Sold out
              </span>
            )}

            <p
              className={`w-full text-left font-bold text-xl  mb-1 ${
                selectedCombo?._id === combo._id
                  ? "text-black dark:text-black"
                  : "text-gray-600 dark:text-gray-400"
              }`}
            >
              X {combo.quantity}
            </p>
            <p
              className={`w-full text-left text-lg mb-4
                ${
                  selectedCombo?._id === combo._id
                    ? "text-black dark:text-black"
                    : "text-gray-600 dark:text-gray-400"
                }`}
            >
              Números
            </p>
            <p
              className={`w-full text-right text-xl font-bold text-primary-600 dark:text-primary-500
              ${
                selectedCombo?._id === combo._id
                  ? "text-primary-600 dark:text-black"
                  : "text-primary-600 dark:text-primary-500"
              }`}
            >
              ${combo.price.toFixed(2)}
            </p>
          </div>
        ))}
      </div>
      <div className="flex justify-center items-center w-full mt-12">
        <TimerProvider onTimeExpire={() => {}}>
          <div className="w-full max-w-md">
            <NcInputNumberLocalities
              enablePurchase={enablePurchase}
              startTime={startTime}
              localityId={localityId}
              haveDiscount={haveDiscount}
              className="w-full"
              onChange={(value) => {
                onChange?.call(null, value);
                setSelectedCombo(undefined);
              }}
              defaultValue={minQuantity}
              maxQuantity={maxQuantity}
              currentQuantity={selectedCombo ? minQuantity : currentQuantity}
              max={max}
              min={minQuantity}
              label={"Te gustaría más números?"}
              desc={""}
              haveSelection={haveSelection}
              endTime={endTime}
              localitiesSelected={localitiesSelected}
              setLocalitiesSelected={setLocalitiesSelected}
              isInput={true}
              eventId={eventId}
            />
          </div>
        </TimerProvider>
      </div>
    </div>
  );
};
